export default "__VITE_ASSET__BxznSpT9__"